module.exports = __webpack_public_path__ + "img/chart-mixed.0343a7b0.svg";